// extracted by mini-css-extract-plugin
export default {"productDescription":"L_-z","featuredDescription":"M_-z","description":"N_-z","more":"O_-z","descriptionSku":"P_-z"};